import { render, staticRenderFns } from "./HolidayPlusChannelDashboard.vue?vue&type=template&id=1ed0078f&scoped=true"
import script from "./HolidayPlusChannelDashboard.vue?vue&type=script&lang=js"
export * from "./HolidayPlusChannelDashboard.vue?vue&type=script&lang=js"
import style0 from "./HolidayPlusChannelDashboard.vue?vue&type=style&index=0&id=1ed0078f&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ed0078f",
  null
  
)

export default component.exports